import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  user: {
    initials: null,
  },
  loading: false,
  loadedUser: null,
  fullyLoaded: false,
  submitting: false,
  submittingProfileChange: false,
});

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOADING_USER:
      return state.set('loading', true).set('fullyLoaded', false);

    case actions.USER_LOADED:
      return state.set('user', action.payload).set('loading', false);

    case actions.USER_FULLY_LOADED:
      return state.set('fullyLoaded', true);

    case actions.LOAD_USER_DATA_DONE:
      return state.set('loadedUser', action.payload);

    case actions.UPDATE_BILLING_START:
      return state.set('submitting', true);

    case actions.UPDATE_BILLING_ERROR:
      return state.set('submitting', false);
    case actions.UPDATE_BILLING_DONE:
      return state.set('loadedUser', action.payload).set('submitting', false);

    case actions.MUTATE_USER_START:
      return state.set('submittingProfileChange', true);
    case actions.MUTATE_USER_DONE:
      return state.set('submittingProfileChange', false);

    case actions.MUTATE_SMART_SORT_SETTINGS_DONE: {
      return state.set('user', {
        ...state.get('user'),
        smartSortSettings: action.payload.smartSortSettings,
      });
    }

    case actions.LOGOUT:
      return initState;
    default:
      return state;
  }
}
